import type {Theme} from '@mui/material/styles';

const ARROW_TRACK_GAP = 2;
const ARROW_SIZE = 40;
const PAGE_CONTENT_WIDTH = 1160;
const MEDIA_QUERY_EPSILON = 0.05;

export const outsideArrowMinViewport = (theme: Theme, gapSpacing: number) =>
  PAGE_CONTENT_WIDTH + 2 * (ARROW_SIZE + Number.parseFloat(theme.spacing(gapSpacing)));

export const carouselArrowSx = (dir: 'prev' | 'next') => (theme: Theme) => {
  const gap = theme.spacing(ARROW_TRACK_GAP);
  const minViewport = outsideArrowMinViewport(theme, ARROW_TRACK_GAP);
  return {
    position: 'absolute' as const,
    top: '50%',
    transform: 'translateY(-50%)',
    [`@media (max-width: ${minViewport - MEDIA_QUERY_EPSILON}px)`]: {display: 'none'},
    ...(dir === 'prev' ? {insetInlineEnd: '100%', marginInlineEnd: gap} : {insetInlineStart: '100%', marginInlineStart: gap}),
  };
};
